import React from 'react';

import { Modal, WrapperFlex } from '@unimed-fesp/components';

import ModalFooter from './ModalFooter';

import { ModalBodyContainer } from './styles';

function ModalConsultaStructure({
  isOpen,
  BodyModal,
  titleModal,
  HeaderModal,
  onCloseModal,
  handleAdicionarModal,

  isDisabledBtnAdicionar,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClick={onCloseModal}
      width={916}
      height={570}
      top={43}
      justifyContentFooter="flex-end"
      header={titleModal}
      footer={
        <ModalFooter
          onCloseModal={onCloseModal}
          handleAdicionarModal={handleAdicionarModal}
          isDisabledBtnAdicionar={isDisabledBtnAdicionar}
        />
      }
    >
      <ModalBodyContainer>
        <WrapperFlex column fullWidth>
          {HeaderModal}
        </WrapperFlex>
        <WrapperFlex column>{BodyModal}</WrapperFlex>
      </ModalBodyContainer>
    </Modal>
  );
}

export default ModalConsultaStructure;
